// Updates the product title to include variant information
// Updates the manufacturer SKU and weight fields
document.addEventListener("on:variant:change", (event) => {
  const variant = event.detail.variant;

  if (variant?.name) {
    document.querySelectorAll(".product-title").forEach(function (e) {
      e.innerHTML = variant.name;
    });
  }

  // Taken from hidden input field on product page
  const variantManufacturerSKU = variant ? document.getElementById(`${variant.id}-manufacturer-sku`).value : null;
  document.getElementById("manufacturer-sku").innerHTML = variantManufacturerSKU ? variantManufacturerSKU : "-";

  // Taken from hidden input field on product page
  const variantWeight = variant ? document.getElementById(`${variant.id}-weight`).value : null;
  document.getElementById("variant-weight").innerHTML = variantWeight ? variantWeight : "-";
});

// Set the initial product title
document.addEventListener("DOMContentLoaded", function (event) {
  if (
    window.ShopifyAnalytics.meta.product.variants.length > 0
  ) {

    let variantID = window.ShopifyAnalytics.meta.product.variants[0].id

    if (window.location.search.split("variant=")[1] !== undefined) {
      variantID = parseInt(window.location.search.split("variant=")[1]);
    }

    const variantTitle = window.ShopifyAnalytics.meta.product.variants.find(
      (x) => x.id === variantID
    ).name;

    if (variantTitle) {
      document.querySelectorAll(".product-title").forEach(function (e) {
        e.innerHTML = variantTitle;
      });
    }
  }
});